import { render, staticRenderFns } from "./index.vue?vue&type=template&id=232f18d5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=232f18d5&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('232f18d5')) {
      api.createRecord('232f18d5', component.options)
    } else {
      api.reload('232f18d5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=232f18d5", function () {
      api.rerender('232f18d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/rightCom/index.vue"
export default component.exports